import { GET_RACKS, GET_RACKS_SUCCESS, GET_RACKS_ERROR} from './actionTypes';

export const getRacks = (user, size, page, status, carrierType, search) => {

    return {
        type: GET_RACKS,
        payload: { user, size, page, status, carrierType, search }
    }
}

export const getRacksSuccess = (racks, message) => {
    return {
        type: GET_RACKS_SUCCESS,
        payload: {racks, message}
    }
}

export const getRacksError = (msg) => {
    return {
        type: GET_RACKS_ERROR,
        payload: msg
    }
}
